import { styled } from '@mui/material/styles';

export const Icon = styled('svg')(() => ({}));

export const Text = styled('span')(({ theme, color }) => ({
  ...(color === 'primary' && {
    color: theme.color.primary.main
  })
}));

export const TitleWrapper = styled('h3')(({ theme, size }) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: size === 'large' ? theme.fontSize.xlarge : theme.fontSize.large,
  fontWeight: theme.fontWeight.normal,
  margin: 0,
  padding: 0,
  [`& ${Icon}`]: {
    marginRight: theme.spacing(2)
  },
  [`& ${Icon} + ${Text}`]: {
    paddingTop: '0.25em'
  }
}));

export const SubTitle = styled('span')(({ theme }) => ({
  color: theme.color.grey['700'],
  fontSize: theme.fontSize.small,
  textTransform: 'none'
}));
